<template>
  <div class="mobile-approval">
      <div class="print-cancellation">
        <div class="print-part">
          <el-col :span="20">
            <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
              <span
                style="
                  color: #ff0000;
                  font-family: 华文中宋;
                  font-size: 32pt;
                  font-weight: bold;
                  letter-spacing: 9pt;
                  text-decoration: none;
                "
                >中国化学工程集团有限公司</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
              <span
                style="
                  color: #ff0000;
                  font-family: Times New Roman;
                  font-size: 13pt;
                  font-weight: bold;
                  letter-spacing: 2pt;
                  text-decoration: none;
                "
              >
                CHINA NATIONAL CHEMICAL ENGINEERING GROUP CO., LTD.
              </span>
            </p>
            <div
              style="border-bottom: 1pt solid #000; margin: 10pt 0 10pt 4pt"
            ></div>
          </el-col>
          <el-col :span="20">
            公函标题
            <span>{{ manageMentInfo.missiveTitle }}</span>
          </el-col>
          <el-col :span="14">
            称呼
            <span>{{ manageMentInfo.callName }}</span>
          </el-col>
          <el-col :span="24">
            公函内容
            <span v-html="manageMentInfo.missiveContent"></span>
          </el-col>
          <div>
            <el-col :span="20">
              联系人
              <span>{{ manageMentInfo.contacts }}</span>
            </el-col>
            <el-col :span="20">
              座机/电话
              <span>{{ manageMentInfo.phoneNumber }}</span>
            </el-col>
            <el-col :span="20">
              开函时间
              <span>{{ manageMentInfo.missiveDate }}</span>
            </el-col>
          </div>
        </div>
      </div>
  </div>
  
</template>
<script>
import LetterManagement from "@/api/foreign/foreign_licence_manage/LetterManagement";
let letterApi = new LetterManagement();
export default {
  data() {
    return {
      type: "",
      manageMentInfo: {
        missiveNumber: "", //公函号
        missiveTitle: "", //标题
        call: "",
        callName: "", //称呼
        missiveContent: "", //公函内容
        contacts: "", //联系人
        phoneNumber: "", //联系电话
        missiveId: "", //公函id
        missiveDate: "", //开函时间
        contas: "",
      },
    };
  },
  methods: {
    init() {
      let obj = {
        missiveId: this.$route.query.id,
      };
      letterApi.detail(obj).then((res) => {
        for (let key in this.manageMentInfo) {
          this.manageMentInfo[key] = res.data[key];
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/documentEdit.css";
.w-e-text {
  height: 200px !important;
}
</style>